import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

const query = graphql`
  query {
    placeholderImage: file(relativePath: { eq: "profile.png" }) {
      relativePath
      name
      childImageSharp {
        fixed(width: 400, height: 400) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`

const BannerImage = props => {
  const data = useStaticQuery(query)

  return <Img fixed={data.placeholderImage.childImageSharp.fixed} {...props} />
}

export default BannerImage
